import { jsx } from "react/jsx-runtime";
import { IconOnly } from "./view.iconOnly.js";
import { TextOnly } from "./view.textOnly.js";
import { TextWithIcon } from "./view.textWithIcon.js";
const componentMap = {
  icon_only: IconOnly,
  text_only: TextOnly,
  text_with_icon: TextWithIcon
};
function FindAWarehouseLink({
  entry,
  linkStyle,
  locale
}) {
  if (!entry || !linkStyle) return null;
  const Component = componentMap[linkStyle];
  if (!Component) {
    console.error(
      "FindAWarehouseLink component mapping missing for linkStyle: ",
      linkStyle
    );
    return null;
  }
  return /* @__PURE__ */ jsx(Component, { entry, locale });
}
export {
  FindAWarehouseLink
};
